import { ErrorMessage } from 'formik'
import styles from '../CustomDomainModal.module.css'
import { OptionButton } from '../CustomDomainModal'
import CTAButton from 'components/CTAButton/CTAButton'
import { ADD_DOMAIN } from '../constants/strings'

const AddDomainAddress = ({ formik, onNext, onPrevious, activeIndex }) => {
    const { errors } = formik
    const inValidDomain = !!errors.dnsAddress?.domain 
  
    return (
      <div className={styles.container}>
        <div className={styles.subHeading}>
          <div className={styles.title}>{ADD_DOMAIN.SUBHEADING}</div>
          <div className={styles.subTitle}>{ADD_DOMAIN.DESCRIPTION}</div>
        </div>
  
        <div className={styles.address}>
          <span className={styles.addressLabel}>Domain name:</span>
          <input
            className={styles.addressInput}
            placeholder="e.g. mywebsite.com"
            type="text"
            {...formik.getFieldProps(`dnsAddress.domain`)}
          />
         <ErrorMessage name="dnsAddress.domain" component="div" className={styles["validation-error"]}/>
        </div>
        <div className={styles.btnContainer} style={{justifyContent: "flex-end"}}>

          <CTAButton
            label="Next"
            onClick={onNext}
            size="small"
            disabled={inValidDomain }
            className={styles.forwardButton}
          />
        </div>
      </div>
    )
  }

export default AddDomainAddress